export default function(to, __, savedPosition) {if (to.hash) {return { selector: to.hash, offset: { x: 0, y: 80 },
          behavior: 'smooth'
        };
      } else if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    }
